import React from 'react';
import '../styles/ThirdPartyTheaters.scss';
import Title from './common/Title';

const ThirdPartyTheaters = ({ theaters = [] }) => {
  console.log('ThirdPartyTheaters theaters:', theaters);
  if (!theaters || theaters.length === 0) return null;

  return (
    <section className="thirdpartytheatters">
      {/* <Title text="You can watch it here as well" className="whiteTitle" /> */}

      <div className="theaters-grid">
        {theaters.map((theater) => (
          <div key={theater.id} className="theater-card">
            <a
              href={theater.link}
              target="_blank"
              rel="noopener noreferrer"
              className="card-link"
            >
              <div className="logo-wrapper">
                <img
                  src={theater.third_party_theater_logo}
                  alt={theater.third_party_theater_name}
                  className="theater-logo"
                />
              </div>
              <div className="theater-name">{theater.third_party_theater_name}</div>
              <div className="book-now">Book Now</div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ThirdPartyTheaters;
